import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { take } from 'rxjs/operators';
import { ApiError, ButtonLoader, MessageService } from '../../../../../../core';
import { arquivoExtensaoTipoOutra, getExtensao } from '../../../../extensoes';
import { ArquivoReferencia } from '../../../../referencias';
import { TipoArquivoFormSelectComponent } from '../../../../tipos/components/form-select';
import { ArquivoSearch } from '../../../arquivo-search';
import { ArquivoBulkUpload } from '../../arquivo-bulk-upload';
import { ArquivoUpload } from '../../arquivo-upload';
import { ArquivoUploadHttpService } from '../../services';


@Component({
    selector: 'sgt-arquivo-upload-modal',
    templateUrl: './arquivo-upload-modal.component.html',
    styleUrls: ['./arquivo-upload-modal.component.less']
})
export class ArquivoUploadModalComponent implements OnInit {
    uploads: ArquivoUpload[];

    // Config
    /** Título do modal */
    @Input() title = 'Adicionar Arquivos';
    /** Subtítulo do modal */
    @Input() subtitle: string = null;
    /** Se deve realizar o upload ao adicionar os arquivos */
    @Input() autoUpload = false;

    referencia: ArquivoReferencia;
    idReferenciaPai: number;
    idReferencia: number;
    @ViewChild('form') form: NgForm;
    @ViewChild('tipoArquivoFormSelect') tipoArquivoFormSelect: TipoArquivoFormSelectComponent;

    @Output() afterAdd = new EventEmitter<ArquivoUpload[]>();
    @Output() afterUpload = new EventEmitter<ArquivoSearch[]>();

    uploader: FileUploader;
    hasBaseDropZoneOver = false;
    isUploading = false;
    @ViewChild('inputFile') inputFile: ElementRef;

    // Modal
    @ViewChild('modal', {static: true}) modal: ElementRef;
    elModal: any;

    constructor(private el: ElementRef,
                private messageService: MessageService,
                private arquivoUploadHttpService: ArquivoUploadHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o uploader para realizar o upload da imagem do avatar */
    private createUploader() {
        this.uploader = new FileUploader({
            autoUpload: false
        });

        this.onAfterAddingFile();
    }


    onFileOver(e: any) {
        this.hasBaseDropZoneOver = e;
    }


    /** Após selecionar o arquivo da imagem */
    private onAfterAddingFile() {
        this.uploader.onAfterAddingFile = (fileItem: FileItem): any => {
            fileItem.withCredentials = false;

            // Obtendo o arquivo original selecionado
            const file = fileItem._file;

            const reader = new FileReader();
            reader.onload = () => {
                // Criando objeto de upload para o arquivo selecionado
                const upload = new ArquivoUpload(this.referencia.id, this.idReferenciaPai, this.idReferencia);
                // Nome do arquivo
                upload.nome = file.name;
                // Obtendo a extensão do arquivo
                const extensao = getExtensao(file.name);
                upload.extensao = extensao ? extensao.id : arquivoExtensaoTipoOutra.id;
                // Tamanho do arquivo
                upload.sizeBytes = file.size;
                // Convertendo o arquivo selecionado em uma string base64
                const base64 = reader.result.toString().substring(reader.result.toString().indexOf(',') + 1);
                upload.file = base64;
                // Adicionando o arquivo para a lista de uploads
                this.uploads.push(upload);
            };
            reader.onerror = (error) => {
              console.error('Erro ao ler o arquivo:', error);
            };

            // Convertendo o arquivo selecionado para Base64
            reader.readAsDataURL(file);
        }
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find(this.modal.nativeElement) as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                this.createUploader();
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(referencia: ArquivoReferencia, idReferenciaPai: number, idReferencia: number) {
        this.referencia = referencia;
        this.idReferenciaPai = idReferenciaPai;
        this.idReferencia = idReferencia;
        this.uploads = [];
        this.elModal.modal({keyboard: false, backdrop: 'static'});
    }

    close() {
        this.clear();
        this.elModal.modal('hide');
    }

    /** Exclui o arquivo desejado */
    delete(index: number) {
        if (index < 0) {
            return;
        }
        this.uploads.splice(index, 1);
    }

    /** Verifica se está válido para realizar o upload dos arquivos */
    private isValid(): boolean {
        // Nenhum arquivo adicionado
        if (!this.uploads || this.uploads.length === 0) {
            this.messageService.warning('Selecione pelo menos 1 arquivo para adicionar ou clique em cancelar para não adicionar', 'Atenção');
            return false;
        }

        return true;
    }

    /** Emite o evento de arquivo adicionado */
    add() {
        if (this.autoUpload) {
            return;
        }
        if (!this.isValid()) {
            return;
        }

        this.afterAdd.emit(this.uploads);
        this.close();
    }

    /** Realiza o upload dos arquivos adicionados */
    bulkUpload() {
        if (!this.afterUpload) {
            return;
        }
        if (!this.isValid()) {
            return;
        }

        const btn = new ButtonLoader('#btnArquivoBulkUpload');
        btn.loading('Adicionando');

        // Criando bulk upload
        const bulk = new ArquivoBulkUpload(this.uploads);
        this.arquivoUploadHttpService.bulkUpload(bulk)
            .pipe(
                take(1)
            )
            .subscribe(
                arquivos => {
                    this.messageService.success('', `${arquivos?.length ?? 0} arquivo(s) adicionados com sucesso`);
                    this.afterUpload.emit(arquivos);
                    btn.reset();
                    this.close();
                },
                (error: ApiError) => {
                    this.messageService.error(error.cause, error.message, error);
                    btn.reset();
                }
            );
    }

    /** Limpa as variáveis do modal */
    private clear() {
        this.referencia = null;
        this.idReferenciaPai = null;
        this.idReferencia = null;
        this.uploader?.destroy();
        this.uploader = null;
    }

    /** Limpa o input file */
    private clearInputFile() {
        const el = this.inputFile.nativeElement as HTMLInputElement;
        el.value = '';
    }
}
